import React from 'react';

const CTAButton = ({ className = '', variant = 'default', onClick }) => {
  const styles = {
    default: 'bg-white text-blue-600 hover:bg-blue-50',
    internal: 'bg-gradient-to-r from-green-500 to-blue-400 text-white hover:from-green-600 hover:to-blue-500'
  };

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <a
      href="https://cotizador.vendetucatalizador.com.mx"
      onClick={handleClick}
      className={`
        group py-3 px-8 rounded-full text-lg font-semibold 
        transition-all duration-300 shadow-lg hover:shadow-xl 
        transform hover:-translate-y-1 relative overflow-hidden inline-block
        ${styles[variant]}
        ${className}
      `}
    >
      Obtén tu Cotización Ahora
    </a>
  );
};

export default CTAButton;
